<template>
  <div class="bg">
    <div class="monthSelectBox">
      <el-date-picker v-model="monthVal" type="month" :clearable="false" format="yyyy-MM" value-format="yyyy-MM" @change="monthChange" :editable="false"></el-date-picker>
    </div>
    <div class="dateBox">
      <div class="week" v-for="week in $t('message.week')">{{week}}</div>
      <div class="days" v-for="(day, index) in calendar" :key="index" @click="checkSIgnInImg(day.qsdnum, day.datastr)">
        <span>{{day.days}}</span>
        <div class="containerLabel" v-if="day.qsdnum !== 0">
          <div class="containerLabelTips">
            <img class="containerIcon" src="@/assets/signInIcon.svg" />
            <span>{{$t('message.containerReceipt')}}({{day.qsdnum}})</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看签收单图片列表 -->
    <el-dialog :visible.sync="showSignInImg" :title="$t('message.containerReceipt')" width="30%" destroy-on-close :close-on-click-modal="false">
      <div class="dialog_box">
        <div class="dialog_row" v-for="(img, index) in signInOrderImg" :key="index" style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 20px;">
          <div style="display: flex;align-items: center;">
            <img class="containerIcon" src="@/assets/signInIcon.svg" />
            <span>{{img.originalfilename}}</span>
          </div>
          <el-link v-if="img.imgurl.includes('.pdf')" type="primary" :underline="false" :href="img.imgurl" target="_blank">
            <img class="checkIcon" src="@/assets/checkIcon.svg" />
          </el-link>
          <img v-else class="checkIcon" @click="checkSignInImg(img.imgurl)" src="@/assets/checkIcon.svg" />
        </div>
      </div>
    </el-dialog>
    <!-- 查看签收单图片 -->
    <el-dialog :title="$t('message.signatureOrderImgTitle')" :visible.sync="showImgDialog" width="25%" destroy-on-close :close-on-click-modal="false" top="30vh" v-cloak>
      <div class="dialog_box">
        <el-image style="width: 100%;height: 100%" :src="imgUrl" :preview-src-list="srcList"></el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { getAmazonSignIn, getSignInImgChekc, imgSrc } from '@/api/getData.js'
  export default {
    name: 'signInCalendar',
    data () {
      let now =  new Date()
      let monthVal = now.getFullYear() + '-' + ((now.getMonth() + 1) > 9 ? (now.getMonth() + 1) : '0' + (now.getMonth() + 1))
      return {
        monthVal: monthVal,
        calendar: [],
        showSignInImg: false,
        signInOrderImg: [],
        showImgDialog: false,
        imgUrl: '',
        srcList: []
      }
    },
    mounted() {
      this.getAmazonSignIn()
    },
    methods: {
      // 月份选择
      monthChange (val) {
        this.monthVal = val
        this.getAmazonSignIn()
      },
      // 查询当前月签收单信息
      async getAmazonSignIn () {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading'
        })
        let param = { DATASTR: this.monthVal, USERID: this.$store.state.JHSS.personalUserid }
        let res = await getAmazonSignIn(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        } else {
          // console.log(res.data)
          let date1 = new Date(res.data[0].datastr)
          let day1 = date1.getDay() === 0 ? 7 : date1.getDay()
          let calendar = []
          for (let i = 0; i < day1 - 1; i++) {
            calendar.push({ datastr: '', days: '', qsdnum: 0 })
          }
          calendar = calendar.concat(res.data)
          let date2 = new Date(res.data[res.data.length - 1].datastr)
          let day2 = date2.getDay() === 0 ? 7 : date2.getDay()
          for (let j = 0; j < 7 - day2; j++) {
            calendar.push({ datastr: '', days: '', qsdnum: 0 })
          }
          this.calendar = calendar
        }
      },
      // 查看签收单图片
      async checkSIgnInImg (num, date) {
        let userid = this.$store.state.JHSS.personalUserid
        if (!userid.includes('admin')) {
          if (num !== 0) {
            const loading = this.$loading({
              lock: true,
              text: 'Loading',
              spinner: 'el-icon-loading'
            })
            let param = { USERID: this.$store.state.JHSS.personalUserid, DATASTR: date }
            let res = await getSignInImgChekc(param)
            loading.close()
            if (res.status !== 200) {
              this.$message.error('network error：' + res.status)
              return
            } else {
              this.signInOrderImg = []
              this.srcList = []
              res.data.dt.forEach(item => {
                this.signInOrderImg = this.signInOrderImg.concat(JSON.parse(item.QSD))
              })
              this.signInOrderImg.forEach(item => {
                item.imgurl = imgSrc(item.filename)
                this.srcList.push(item.imgurl)
              })
              this.showSignInImg = true
            }
          }
        } else {
          this.$router.push({ path: `/signInImgList/${date}` })
        }
      },
      // 查看签收单图片
      checkSignInImg (imgurl) {
        this.imgUrl = imgurl
        this.showImgDialog = true
      }
    }
  }
</script>

<style scoped>
[v-cloak] {
  display: none;
}
.monthSelectBox {
  width: 100%;
  height: 78px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 6px;
}
.dateBox {
  width: 100%;
  height: calc(100% - 78px);
  height: -moz-calc(100% - 78px);
  height: -webkit-calc(100% - 78px);
  /* background: #FFFFFF; */
  padding: 0 65px 22px;
  overflow-y: scroll;
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
}
.dateBox::-webkit-scrollbar { width: 0 !important; }
.dateBox { /* -ms-overflow-style: none; */ -ms-overflow-x: unset; }
.dateBox { overflow: -moz-hidden-unscrollable; }
.week {
  flex-shrink: 0;
  width: 14.28%;
  height: 54px;
  background: #EEF0F5;
  font-size: 18px;
  color: #333333;
  line-height: 54px;
  border: 1px solid #FFFFFF;
  border-radius: 8px 8px 0 0;
}
.days {
  flex-shrink: 0;
  width: 14.28%;
  height: 147px;
  background: #FFFFFF;
  font-size: 36px;
  color: #333333;
  line-height: 42px;
  border: 1px solid #EEF0F5;
  padding: 28px 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: stretch;
  cursor: default;
}
.containerLabel {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  /* padding: 0 19px; */
}
.containerLabelTips {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #666666;
}
.containerIcon {
  flex-shrink: 0;
  width: 21px;
  height: 24px;
  margin-right: 5px;
}
.checkIcon {
  width: 22px;
  height: 22px;
  cursor: pointer;
}
</style>
